export default {
  SET_REPORT_WIDGET_DATA: "SET_REPORT_WIDGET_DATA",
  SET_WIDGET_LIST: "SET_WIDGET_LIST",
  SET_REPORT_WIDGET_FETCH_STATE: "SET_REPORT_WIDGET_FETCH_STATE",
  SET_DASHBOARD_LIST: "SET_DASHBOARD_LIST",
  // SET_DASHBOARD_LIST_FETCH_STATE: "SET_DASHBOARD_LIST_FETCH_STATE",
};
